<div class="container-fluid" #divLoginPage>
  <div class="row mh-100vh">
    <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
      <div class="m-auto register-login w-lg-75 w-xl-50">
        <div class="text-center mb-5"><img src="/assets/images/CFN-LOGO-Validated.svg" style="width: 185px;"></div>
        <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">S'authentifier<br></h2>

        <form [formGroup]="verifyCodeForm" action="#" novalidate>

          <div class="alert alert-danger" *ngIf="submitted && isError">
            Code invalide.
          </div>
          <div class="input-group form-group">
            <div class="row">
              Valider votre code d'authentification à deux facteurs
            </div>
          </div>
          <div class="input-group form-group">
            <code-input name="receivedToken" [isCodeHidden]="false" [isCharsCode]="true"
                        [codeLength]="6"
                        (codeCompleted)="verifyCode($event)">
            </code-input>
          </div>
          <div style="display: flex;flex-direction:row;align-items:center; justify-content: center;">
            <div style="padding:0.2rem">
              <button type="button" class="btn btn-primary" (click)="backToSendCode()">
                <span class="btn-label">
                  <i class="pi pi-arrow-left"></i>
                </span>Retour
              </button>
            </div>
            <div style="padding:0.2rem">
              <button type="button" class="btn btn-primary" (click)="reSendCode()" [disabled]="timer.isTicking()">
                <div style="display: flex;justify-content: center;">
              
                  <flx-circle-timer #timer
                  color="#fff"
                  [duration]="duration"></flx-circle-timer>
                  Renvoyer le code
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>

    </div>
    <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
      <div></div>
    </div>
  </div>
</div>
